import { gChartGeoMainMapName } from '../models/generic-chart-settings/g-chart-geo';

export const chartMapLoader = (echarts) => {
  echarts.registerMap(gChartGeoMainMapName, {
    specialAreas: {},
    // geoJSON: geoJsonFull as any,
  });
};
